import { render, staticRenderFns } from "./aliLogin.vue?vue&type=template&id=94b298f4&scoped=true&lang=html&"
import script from "./aliLogin.vue?vue&type=script&lang=js&"
export * from "./aliLogin.vue?vue&type=script&lang=js&"
import style0 from "./aliLogin.vue?vue&type=style&index=0&id=94b298f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b298f4",
  null
  
)

export default component.exports